// useS3Upload.js
import { useState } from 'react';
import { Storage } from 'aws-amplify';

const useS3Upload = () => {
  const [selectedFiles, setSelectedFiles] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState({});

  const handleFileInput = (event) => {
    setSelectedFiles(event.target.files);
    setUploadProgress(0);
    setUploadStatus({});
  };

  const uploadToS3 = async (selectedBucket, files, date_stamp) => {
    console.log('selectedBucket', selectedBucket);
    if (!files || files.length === 0) {
      console.log('No files selected.');
      return;
    }

    if (!selectedBucket) {
      console.log('No bucket selected.');
      return;
    }

    let i;
    try {
      for (let i = 0; i < files.length; i++) {
        setUploadStatus(prevState => ({ ...prevState, [files[i].name]: 'Uploading' }));
        const result = await Storage.put(
          selectedBucket + '/raw_data/' + date_stamp + '/' + files[i].name,
          files[i],
          { 
            customPrefix: { public: '' },
            progressCallback: progress => { 
              const percentUploaded = Math.round((progress.loaded / progress.total) * 100);
              setUploadProgress(percentUploaded);
            } 
          }
        );
        setUploadStatus(prevState => ({ ...prevState, [files[i].name]: 'Uploaded' }));
        console.log('File uploaded successfully:', result);
      }
      setUploadStatus('Done');
      setUploadProgress(0);
    } catch (error) {
      console.log('An error occurred while uploading the file.', error);
      setUploadStatus(prevState => ({ ...prevState, [files[i].name]: 'Error' }));
    }
  };
  
  return { selectedFiles, handleFileInput, uploadToS3, uploadProgress, uploadStatus };
};

export default useS3Upload;